<!--
 * @Description: 后台管理布局
 * @Author: shangao
 * @Date: 2022-04-26 11:19:07
 * @LastEditTime: 2022-05-06 09:11:27
 * @LastEditors: shangao
 * @FilePath: \teaching-web\src\layouts\ManageLayout.vue
-->
<template>
  <div class="manage-layout">
    <div class="header">
      <div class="header-container">
        <div class="left">
          <router-link to="/home"><h2 class="logo">教研新空间</h2></router-link>
          <el-divider direction="vertical"></el-divider>
          <h2>后台管理</h2>
        </div>
        <AvatarDropdown class="right" />
        <!-- <div class="right">
          <el-dropdown>
            <div class="app-header-user">
              <img
                v-if="userInfo.photo && userInfo.photo.length > 0"
                class="app-header-avatar"
                :src="userInfo.photo"
              />
              <div class="app-header-username">
                {{ userInfo.userName | splitName }}
              </div>
              <i class="app-header-dropdown el-icon-caret-bottom"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
      </div>
    </div>
    <el-menu v-if="!invisible" mode="horizontal" :default-active="activeIndex">
      <el-menu-item v-for="item in menus" :key="item.index" :index="item.index">
        <router-link :to="item.path">{{ item.title }}</router-link>
      </el-menu-item>
    </el-menu>
    <router-view class="page-container" />
    <div class="footer">技术支持：科大讯飞股份有限公司</div>
  </div>
</template>
<script>
// import { mapState } from 'vuex'
import AvatarDropdown from './AvatarDropdown.vue'
import './manage.less'
export default {
  name: 'ManageLayout',
  components: { AvatarDropdown },
  data () {
    return {
      menus: [],
      invisible: false,
      activeIndex: ''
    }
  },
  // computed: {
  //   ...mapState({
  //     userInfo: state => state.userInfo
  //   }),
  // },
  watch: {
    $route: {
      immediate: true,
      handler: function () {
        this.updateActive()
      }
    }
  },
  // filters: {
  //   splitName (name) {
  //     if (name) {
  //       if (name.length > 4) {
  //         return `${name.substring(0, 4)}..`;
  //       } else {
  //         return name;
  //       }
  //     }
  //   },
  // },
  created () {
    this.getMenu()
  },
  methods: {
    // 获取目录菜单
    getMenu () {
      const manage = this.$router.options.routes.find(item => item.path === '/manage')
      if (manage && manage.children) {
        const menus = []
        manage.children.forEach(item => {
          if (item.meta && !item.meta.invisible) {
            menus.push({ ...item.meta, path: item.path })
          }
        })
        console.log(JSON.parse(JSON.stringify(menus)))
        this.menus = menus
      }
    },
    // 菜单选中
    updateActive () {
      const meta = this.$route.meta
      if (meta && meta.index) {
        this.activeIndex = meta.index
        // this.invisible = meta.invisible
      }
      this.invisible = meta ? meta.invisible : false
    },
    // // 退出登录
    // logout () {
    //   this.$store.dispatch('Logout')
    // }
  }
}
</script>
<style lang="less">
.el-dropdown-menu__item, .el-menu-item{
  padding: 0px 0px!important;
  a{
    width: 104px;
    display: inherit;
    text-align: center;
  }
}
</style>